import { BillingStageScheduleType, StageScheduleContext } from '~/models';
export const scheduleTextsPath = 'billing.stages.schedule';
export const TODAY_OPTION_VALUE = 'today';
export const getScheduleOptions = (params)=>{
    const { context, texts } = params;
    const options = texts.options;
    const onAcceptance = {
        value: BillingStageScheduleType.OnEffectiveDate,
        label: options.onAcceptance.text(),
        subtext: options.onAcceptance.subtext()
    };
    const onEffectiveDate = {
        value: BillingStageScheduleType.OnEffectiveDate,
        label: options.onEffectiveDate.text(),
        subtext: options.onEffectiveDate.subtext()
    };
    const relativeToAcceptance = {
        value: BillingStageScheduleType.RelativeToEffectiveDate,
        label: options.relativeToAcceptance.text(),
        subtext: options.relativeToAcceptance.subtext()
    };
    const relativeToEffectiveDate = {
        value: BillingStageScheduleType.RelativeToEffectiveDate,
        label: options.relativeToEffectiveDate.text(),
        subtext: options.relativeToEffectiveDate.subtext()
    };
    const onDate = {
        value: BillingStageScheduleType.OnDate,
        label: options.onDate.text(),
        subtext: options.onDate.subtext()
    };
    const manual = {
        value: BillingStageScheduleType.Manual,
        label: options.manual.text(),
        subtext: options.manual.subtext()
    };
    if (context === StageScheduleContext.Amendment) {
        const amendment = texts.amendment;
        const amendmentToday = {
            value: TODAY_OPTION_VALUE,
            label: amendment.today.text(),
            subtext: amendment.today.subtext()
        };
        const amendmentOnDate = {
            value: BillingStageScheduleType.OnDate,
            label: amendment.onDate.text(),
            subtext: amendment.onDate.subtext()
        };
        const amendmentManual = {
            value: BillingStageScheduleType.Manual,
            label: amendment.manual.text(),
            subtext: amendment.manual.subtext()
        };
        return [
            amendmentToday,
            amendmentOnDate,
            amendmentManual
        ];
    }
    switch(context){
        case StageScheduleContext.ProposalOnAcceptance:
            return [
                onAcceptance,
                relativeToAcceptance,
                onDate,
                manual
            ];
        case StageScheduleContext.ProposalOnEffectiveDate:
            return [
                onEffectiveDate,
                relativeToEffectiveDate,
                onDate,
                manual
            ];
        case StageScheduleContext.Template:
            return [
                onAcceptance,
                relativeToAcceptance,
                onDate,
                manual
            ];
    }
};
